export function calculatePercentageAmount(total: number, percentage: number) {
    return (total * percentage) / 100;
}